import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-dv-sv',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-dv-sv.component.html',
  styleUrl: './tekst-dv-sv.component.scss',
})
export class TekstDvSvComponent {}
